import { convertFileToBase64 } from "../../../utils/getBase64";

// eslint-disable-next-line import/prefer-default-export
export const mapSupplierDataToApi = async (data, id) => ({
    data: {
        type: "suppliers",
        ...(id && { id }),
        attributes: {
            name: data.arabicName,
            phoneNumber: data.phoneNumber,
            nationalId: data.nationalId,
            organizationId: data?.organizationId?.value ? Number(data?.organizationId?.value) : null,
            supplierType: data.supplierType?.value,
            workingTruckTypes: data.truckTypes?.map((element) => element?.value),
            workingGovernorates: data.workingGovernorates?.map((element) => element?.value),
            companyName: data.hasACompany?.value === false ? null : data.companyName,
            email: data.email,
            ...(id && { paymentMethodDelete: data.paymentMethodDelete }),
            ...((!id || (id && data.hasACompany?.label)) && {
                hasACompany: data.hasACompany?.label ? data.hasACompany?.value : null,
            }),
            // hasACompany: data.hasACompany?.label ? data.hasACompany?.value : null,
            ...((!id || (id && data.nationalIdFace?.length > 0)) && {
                nationalIdFace: data.nationalIdFace?.[0]
                    ? await convertFileToBase64(data.nationalIdFace[0])
                    : null,
            }),
            ...((!id || (id && data.nationalIdBack?.length > 0)) && {
                nationalIdBack: data.nationalIdBack?.[0]
                    ? await convertFileToBase64(data.nationalIdBack[0])
                    : null,
            }),
            ...((!id || (id && data.commercialRegistrationAttachments?.length > 0)) && {
                commercialRegister: data.commercialRegistrationAttachments?.[0]
                    ? await convertFileToBase64(data.commercialRegistrationAttachments[0])
                    : null,
            }),
            ...((!id || (id && data.supplierPictureAttachments?.length > 0)) && {
                picture: data.supplierPictureAttachments?.[0]
                    ? await convertFileToBase64(data.supplierPictureAttachments[0])
                    : null,
            }),
            ...((!id || (id && data.taxCardAttachments?.length > 0)) && {
                taxCard: data.taxCardAttachments?.[0]
                    ? await convertFileToBase64(data.taxCardAttachments[0])
                    : null,
            }),
        },
        ...(data.paymentMethod?.label && {
            relationships: {
                paymentMethod: {
                    data: {
                        type: "paymentMethod",

                        // eslint-disable-next-line no-nested-ternary
                        ...(data.paymentMethod?.value === "bank_account"
                            ? {
                                attributes: {
                                    accountHolderName: data.accountHolderName,
                                    methodType: data.paymentMethod.value,
                                    bankName: data.bankName.label,
                                    bankAccountNumber: data.bankAccountNumber,

                                    bankIban: data.ibanNumber,
                                },
                            }
                            : data.paymentMethod?.value === "e_wallet"
                                ? {
                                    attributes: {
                                        accountHolderName: data.accountHolderName,
                                        methodType: data.paymentMethod.value,
                                        eWalletType: data.eWalletName.value,
                                        eWalletNumber: data.eWalletNumber,
                                    },
                                }
                                : data.paymentMethod?.value === "mezza_card"
                                    ? {
                                        attributes: {
                                            accountHolderName: data.accountHolderName,
                                            methodType: data.paymentMethod.value,
                                            mezzaCardType: data.mezzaCardName?.label,
                                            mezzaCardNumber: data.meezaCardNumber,
                                        },
                                    }
                                    : {}),
                    },
                },
            },
        }),
    },
});
